require('./profileDropdown.directive')
require('./profileDropdown.directive')
require('./quagga-barcode.directive')
require('./edgeEvents.directive')
require('./edgeReports.directive')
require('./edgeRecordingList.directive')
require('./organizationManage.directive')
require('./eventsDashboard.directive')
require('./reportsDashboard.directive')
require('./edgelist.directive')
require('./edgeListV2.directive')
require('./broadcast.videos.directive')
require('./broadcastVideosV2.directive')
require('../others/qifi/jquery.qrcode')
require('../others/qifi/jquery.storage')
require('./edge.qifi.directive')
require('./numberOnly.directive')
require('./languages.directive')
require('./edgeTrip.directive')
require('./edgeAggressiveReports.directive')
require('./edgeSpeedingReport.directive')
require('./edgeGeofenceReport.directive')
require('./edgeDangerousDrivingReports.directive')
require('./ng-simplebar.directive')
require('./ngTableLoading.directive')
require('./recordingVideo.directive')
require('./custom-datepicker.directive')
require('./custom-timepicker.directive')
require('./recordingTimeline.directive')
require('./event-recordings-player.directive')
require('./surf-mp4-player.directive')
require('./surf-mp4-player-with-accelerometer.directive')
require('./surf-snapshot.directive')
require('./health-reports/health-reports-list.directive')
require('./health-reports/health-reports-health.directive')
require('./health-reports/health-reports-alarms.directive')
require('./device-ui-settings-edit.directive')
require('./custom-accelerometer-line-chart.directive')
require('./ad-on-md-drag.directive')
require('./map-media-players.directive')
require('./notifications.items.directive')
require('./privacy-mode-settings-edit.directive')
require('./health-reports/health-reports-data-usage.directive')
